import React from 'react';
import { useDeepEqualMemo } from './hooks/useDeepEqualMemo';
export const DamzContext = /*#__PURE__*/ React.createContext({});
DamzContext.displayName = 'DamzContext';
export const DamzContextProvider = (props)=>{
    const ctx = useDeepEqualMemo(props.context);
    return /*#__PURE__*/ React.createElement(DamzContext.Provider, {
        value: ctx
    }, props.children);
};
DamzContextProvider.displayName = 'DamzContextProvider';

//# sourceMappingURL=DamzContext.js.map